import { useDispatch, useSelector } from "react-redux"
import { Paper, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core"
import { formatDinero } from "./../../../utils/formatDinero"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { useState } from "react"
import { consultaSolicitudesPasajeroAction, aceptPasajeroAction, declinePasajeroAction, consultaDetalleViajeAction } from "../../../ducks/cambiosDuck"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
import { catEstatusCambioPasajero } from "./../../../constant/catEstatusCambioPasajero"
import { Alert } from "@material-ui/lab"
const Solicitudes = () => {
    const { cliente, referencia, solicitudesPasajeros } = useSelector(store => store.cambios)
    const solicitudes = solicitudesPasajeros
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleDisponible = () => {
        DialogMessage.fire({
            title: `Cambio psajero`,
            text: `¿Confirmar que si hay disponibilidad de pasajeros para esta referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(aceptPasajeroAction({ IdSolicitud: solicitudes.IdSolicitudAgregarPasajeros })).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(consultaDetalleViajeAction())
                    dispatch(consultaSolicitudesPasajeroAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    const handleNoDiponible = () => {
        DialogMessage.fire({
            title: `Cambio psajero`,
            text: `¿Confirmar que no hay disponibilidad de pasajeros para esta referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(declinePasajeroAction({ IdSolicitud: solicitudes.IdSolicitudAgregarPasajeros })).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(consultaSolicitudesPasajeroAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    if (solicitudesPasajeros.IdSolicitudAgregarPasajeros > 0) return (
        <div style={{ margin: "1rem 0" }}>
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Solicitud</TableCell>
                            <TableCell align="center">Nombre</TableCell>
                            <TableCell align="center">Estatus</TableCell>
                            <TableCell align="center">Cantidad</TableCell>
                            <TableCell align="center">Monto Requerido</TableCell>
                            <TableCell align="center">Fecha vencimiento</TableCell>
                            <TableCell align="center">Acción</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="center">
                                {
                                    (solicitudes?.Adultos > 0) ? "Adultos" : null
                                }
                                {
                                    (solicitudes?.Menores > 0) ? "Menores" : null
                                }
                                {
                                    (solicitudes?.Infantes > 0) ? "Infantes" : null
                                }
                            </TableCell>
                            <TableCell align="center">{`Agregar nuevo pasajero`}</TableCell>
                            <TableCell align="center">
                                {`${solicitudes?.EstatusAgregarPasajero?.Descripcion}`}
                            </TableCell>
                            <TableCell align="center">
                                {solicitudes?.Cantidad}
                            </TableCell>
                            <TableCell align="center">
                                {(solicitudes?.EstatusAgregarPasajero?.IdCatalogo === catEstatusCambioPasajero.VALIDA_DISPONIBILIDAD) ? "No aplica" : formatDinero(solicitudes?.MontoRequerido)}
                            </TableCell>
                            <TableCell align="center">
                                {(solicitudes?.EstatusAgregarPasajero?.IdCatalogo === catEstatusCambioPasajero.VALIDA_DISPONIBILIDAD) ? "No aplica" : FormatoFechaIso({ date: solicitudes?.FechaLimite, formato: "dd MMMM yyyy" })}
                            </TableCell>
                            <TableCell align="center">
                                {
                                    (solicitudes?.EstatusAgregarPasajero?.IdCatalogo === catEstatusCambioPasajero.VALIDA_DISPONIBILIDAD) &&
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0.2rem" }}>
                                        <Button variant="contained" color="secondary" onClick={handleDisponible}>Dispoble</Button>
                                        <Button variant="contained" color="default" onClick={handleNoDiponible}>No disponible</Button>
                                    </div>
                                }
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <BackDrop open={load} />
        </div>
    )
    return (
        <Alert className="alerta" severity="info">No hay solicitudes pendientes</Alert>
    )
}
export default Solicitudes